import { action, makeObservable, observable } from 'mobx';
import { FormControl } from 'shared/libs/form';
import { v4 as uuidv4 } from 'uuid';

export class JobLangGroupItemModel {
   id = uuidv4();
   hidden: boolean = false;
   show(): void {
      this.hidden = false;
   }

   hide(): void {
      this.hidden = true;
      this.langFormControl.setValue('');
      this.langSkillFormControl.setValue('');
   }

   constructor(
      public readonly langFormControl: FormControl<string>,
      public readonly langSkillFormControl: FormControl<string>
   ) {
      makeObservable(this, {
         hidden: observable,
         show: action.bound,
         hide: action.bound,
      });
   }
}
